import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import WebLayout from "../../../layout/WebLayout";
import { RootState } from "../../../stores";
import Select from "react-select";
import CategoryAction from "../../../stores/actions/categoryAction";
import VendorAction from "../../../stores/actions/VendorAction";
import ProductAction from "../../../stores/actions/ProductAction";
import AddToCart from "../../../components/AddToCart";
import { toast } from "react-toastify";
import POProductAction from "../../../stores/actions/POProductAction";
import { useNavigate } from "react-router-dom";
import OrderAction from "../../../stores/actions/OrderAction";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import UpdateCart from "../../../components/UpdateCart";
import CartAction from "../../../stores/actions/CartAction";
import ProfileAction from "../../../stores/actions/profileAction";
import { storeCookie } from "../../../utils/CookieAction";
import { INDIAN_MSME_USER_TYPE } from "../../../utils/Constants";
import RegistrationAction from "../../../stores/actions/registrationAction";

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 8,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 4,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

const PoGenerate = () => {
  const type = "BUYER";

  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  let grandTotal = 0;
  const {
    recentOrders,
    poProductList,
    termsAndConditions,
    deliveryCharge,
    minOrderAmount,
    productViewStatus,
    requestStatus,
  } = useSelector((state: RootState) => state.product);

  const { cartList, totalQty, totalTax, totalAmount, totalPV } = useSelector(
    (state: RootState) => state.cart
  );

  const { poVendorList, poSellerUniqueList } = useSelector(
    (state: RootState) => state.po_product
  );
  const { categoryList, subCategoryList, childCategoryList } = useSelector(
    (state: RootState) => state.category
  );

  const { profileDetails } = useSelector((state: any) => state.auth);

  const { stateList } = useSelector((state: RootState) => state.profile);
  const { allCityList } = useSelector((state: RootState) => state.profile);

  const [loader, setLoader] = useState<boolean>(false);
  const [search, setSearch] = useState<any>("");
  const [category, setCategory] = useState<any>("");
  const [subCategory, setSubCategory] = useState<any>("");
  const [childCategory, setChildCategory] = useState<any>("");
  const [vendorID, setVendorId] = useState<any>("");
  const [sellerID, setSellerId] = useState<any>("");
  const [state, setState] = useState<any>("");
  const [city, setCity] = useState<any>("");
  const [terms, setTerms] = useState<any>(false);

  if (type === "BUYER") {
    storeCookie(INDIAN_MSME_USER_TYPE, JSON.stringify(type));
  }

  const getVendorList = useCallback(async () => {
    await dispatch(
      POProductAction.vendorList({
        city: city.value,
      })
    );
  }, [dispatch, city]);

  const getSellerUniqueId = useCallback(async () => {
    await dispatch(POProductAction.getSellerUniqueId());
  }, [dispatch]);

  const getCategoryList = useCallback(async () => {
    await dispatch(
      CategoryAction.getCategory({
        search: "",
        limit: 100,
        offset: 0,
        keyword: "",
        sortBy: "",
        sortType: "",
      })
    );
  }, [dispatch]);

  const getSubCategoryList = useCallback(async () => {
    await dispatch(
      CategoryAction.getSubCategory({
        search: "",
        limit: 100,
        offset: 0,
        keyword: "",
        sortBy: "",
        sortType: "",
        category: category,
        type: "filter",
      })
    );
  }, [dispatch, category]);

  const getChildCategoryList = useCallback(async () => {
    await dispatch(
      CategoryAction.getChildCategory({
        search: "",
        limit: 100,
        offset: 0,
        keyword: "",
        sortBy: "",
        sortType: "",
        sub_category: subCategory,
        type: "filter",
      })
    );
  }, [dispatch, subCategory]);

  const getProductList = useCallback(async () => {
    await dispatch(
      ProductAction.getProductForPO({
        categoryId: category?.value,
        subCategoryId: subCategory?.value,
        childCategoryId: childCategory?.value,
        vendorId: vendorID?.value,
        sellerUniqueId: sellerID?.value,
        city: city,
      })
    );
  }, [
    dispatch,
    category,
    subCategory,
    childCategory,
    vendorID,
    sellerID,
    state,
  ]);

  const recentOrderList = useCallback(async () => {
    await dispatch(OrderAction.getRecentOrders());
  }, [dispatch]);

  const getCartList = useCallback(async () => {
    await dispatch(CartAction.cartList());
  }, [dispatch]);

  const getStateList = useCallback(async () => {
    await dispatch(ProfileAction.getState());
  }, [dispatch]);

  const getAllCityList = useCallback(async () => {
    await dispatch(ProfileAction.getAllCity());
  }, [dispatch]);

  useEffect(() => {
    getVendorList();
    getCategoryList();
    getSubCategoryList();
    getChildCategoryList();
    getProductList();
    recentOrderList();
    getCartList();
    getSellerUniqueId();
    getStateList();
    getAllCityList();
  }, [
    getVendorList,
    getCategoryList,
    getSubCategoryList,
    getChildCategoryList,
    getProductList,
    recentOrderList,
    getCartList,
    getSellerUniqueId,
    getStateList,
    getAllCityList,
  ]);

  const categoryOptions = categoryList?.map((cate: any) => {
    return {
      value: cate.id,
      label: cate.name,
    };
  });

  const subCategoryOptions = subCategoryList?.map((subCate: any) => {
    return {
      value: subCate.id,
      label: subCate.name,
    };
  });

  const childCategoryOptions = childCategoryList?.map((childCate: any) => {
    return {
      value: childCate.id,
      label: childCate.name,
    };
  });

  const vendorOptions: any = poVendorList;

  const sellerOptions: any = poSellerUniqueList;
  const handleSearch = (e: any) => {
    setSearch(e.target.value);
  };

  const filteredData = poProductList?.filter((item: any) =>
    item.product_name.toLowerCase().includes(search.toLowerCase())
  );

  const handleCategory = (e: any) => {
    setCategory(e);
  };

  const resetFilter = () => {
    setCategory("");
    setSubCategory("");
    setChildCategory("");
    setVendorId("");
    setSellerId("");
  };
  const proceedToPayment = async () => {
    if (totalAmount === 0) {
      toast.error("To generate PO you must first add the product to cart");
      return false;
    } else if (terms === false) {
      toast.error("To generate PO you must first accept terms and conditions");
      return false;
    } else if (minOrderAmount >= totalAmount) {
      toast.error("Minimum order should be Rs " + minOrderAmount);
      return false;
    }
    setLoader(true);

    try {
      await dispatch(
        POProductAction.requestPoGenerate({
          delivery_charge: deliveryCharge,
          terms,
        })
      );
      navigate("/po-list/requested");
      setLoader(false);
    } catch (error: any) {
      toast.error(error.message);
      setLoader(false);
    }
  };

  const stateOptions = allCityList?.map((city: any) => {
    return {
      value: city.name,
      label: city.name,
    };
  });

  const [catModal, setCatModal] = useState<boolean>(false);
  const modalOpen = () => {
    setCatModal(true);
  };

  const handleClose = () => setCatModal(false);

  const devAmt = totalQty == 0 ? "0.00" : deliveryCharge;

  const sendRequest = async (id: number, status: string) => {
    try {
      await dispatch(
        RegistrationAction.bsSendRequest({
          id: id,
          status: status,
        })
      );
      getProductList();
      toast.success("Your request has been sent successfully!");
    } catch (error) {
      toast.error("Error in sending request");
    }
  };

  return (
    <WebLayout pageName={"PoGenerate"}>
      <div className="content-wrapper" style={{ zoom: "70%" }}>
        <div className="container-fluid flex-grow-1 pt-2">
          <div className="card">
            <div className="px-2">
              <div className="row">
                <div className="col-12">
                  <div className="row">
                    <div className="col-12 col-sm-6 col-lg-2">
                      <label className="form-label">City</label>
                      <Select
                        value={city}
                        onChange={setCity}
                        options={stateOptions}
                      />
                    </div>
                    <div className="col-12 col-sm-6 col-lg-2">
                      <label className="form-label">Seller</label>
                      <Select
                        value={vendorID}
                        onChange={setVendorId}
                        options={vendorOptions}
                      />
                    </div>
                    <div className="col-12 col-sm-6 col-lg-2">
                      <label className="form-label">Category</label>
                      <Select
                        value={category}
                        onChange={handleCategory}
                        options={categoryOptions}
                      />
                    </div>
                    <div className="col-12 col-sm-6 col-lg-2">
                      <label className="form-label">Sub Category</label>
                      <Select
                        value={subCategory}
                        onChange={setSubCategory}
                        options={subCategoryOptions}
                      />
                    </div>
                    <div className="col-12 col-sm-6 col-lg-2">
                      <label className="form-label">Brand</label>
                      <Select
                        value={childCategory}
                        onChange={setChildCategory}
                        options={childCategoryOptions}
                      />
                    </div>

                    <div className="col-12 col-sm-6 col-lg-2">
                      <label className="form-label"></label>
                      <br />
                      <button
                        className={"btn btn-danger btn-sm"}
                        onClick={resetFilter}>
                        Reset Filter
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {poProductList?.length > 0 ? (
                productViewStatus === "PUBLIC" ||
                requestStatus === "ACCEPTED" ? (
                  <div className="card-datatable table-responsive mt-3">
                    <div className="row">
                      <div className="col-md-12">
                        <input
                          type="text"
                          placeholder="Search..."
                          value={search}
                          className={"form-control form-control-sm"}
                          onChange={handleSearch}
                        />
                      </div>
                    </div>
                    <hr />

                    <div className={"row mt-4"}>
                      <div className={"col-md-8"}>
                        {/* {recentOrders?.length > 0 ? (
                        <>
                          <h5 className={"m-1"}>Recent Orders</h5>
                          <Carousel
                            additionalTransfrom={0}
                            arrows
                            centerMode={false}
                            focusOnSelect={false}
                            minimumTouchDrag={80}
                            renderButtonGroupOutside={false}
                            renderDotsOutside={false}
                            swipeable={true}
                            draggable={true}
                            showDots={false}
                            responsive={responsive}
                            ssr={true}
                            autoPlay={false}
                            autoPlaySpeed={5000}
                            keyBoardControl={true}
                            customTransition="all .5"
                            transitionDuration={500}
                            removeArrowOnDeviceType={["tablet", "mobile"]}
                            deviceType={"desktop"}
                          >
                            {recentOrders?.map((data: any) => {
                              return (
                                <div
                                  className="card h-100 shadow-none border"
                                  style={{ borderRadius: 0 }}
                                >
                                  <div className="card-body p-3 pt-2 d-flex justify-content-between flex-column">
                                    <div className="rounded-2 text-center">
                                      <img
                                        className="img-fluid"
                                        src={data.product_image}
                                        alt={data.product_name}
                                        width={150}
                                        style={{
                                          height: 100,
                                          objectFit: "contain",
                                        }}
                                      />
                                      <br />
                                      <p className="badge bg-label-primary mt-2 mb-0">
                                        {data.product_code}
                                      </p>

                                      <p
                                        title={data.product_name}
                                        className={"mb-0"}
                                        style={{
                                          fontSize: 12,
                                          fontWeight: "bold",
                                        }}
                                      >
                                        {data.product_name.substring(0, 50)}
                                      </p>
                                      <p className={"text-success mb-0"}>
                                        Rs. {data.landingCostTaxAfterMarginSet}
                                      </p>
                                    </div>
                                    <AddToCart
                                      productId={data.id}
                                      cartData={getCartList}
                                    />
                                  </div>
                                </div>
                              );
                            })}
                          </Carousel>
                        </>
                      ) : null} */}
                        <div
                          className={"row"}
                          style={{ height: 400, overflowY: "scroll" }}>
                          {filteredData.map((data: any) => {
                            grandTotal = Number(totalAmount) + Number(devAmt);
                            return (
                              <div
                                className="col-sm-6 mb-2"
                                style={{ width: "20%" }}>
                                <div
                                  className="card h-100 shadow-none border"
                                  style={{ borderRadius: 0 }}>
                                  <div className="card-body p-3 pt-2 d-flex justify-content-between flex-column">
                                    <div className="rounded-2 text-center">
                                      <img
                                        className="img-fluid"
                                        src={data.product_image}
                                        alt={data.product_name}
                                        width={150}
                                        style={{
                                          height: 100,
                                          objectFit: "contain",
                                        }}
                                      />
                                      <br />
                                      <p className="badge bg-label-primary mt-2 mb-0">
                                        {data.product_code}
                                      </p>

                                      <p
                                        title={data.product_name}
                                        className={"mb-0"}
                                        style={{
                                          fontSize: 12,
                                          fontWeight: "bold",
                                        }}>
                                        {data.product_name.substring(0, 50)}
                                      </p>
                                      <p className={"text-success mb-0"}>
                                        Rs.{" "}
                                        {data.landingCostTaxAfterMarginSet.toFixed(
                                          2
                                        )}
                                      </p>
                                    </div>
                                    <AddToCart
                                      productId={data.id}
                                      minSaleQty={data.min_sale_qty}
                                      cartData={getCartList}
                                      getProductList={getProductList}
                                      state={state.value}
                                      cartStatus={data.cart}
                                    />
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                      <div className={"col-md-4"}>
                        <div>
                          <label
                            className="form-check mb-2"
                            onClick={() => modalOpen()}>
                            <input
                              type="checkbox"
                              className="form-check-input"
                              required
                              value={terms}
                              onChange={() => setTerms(!terms)}
                            />
                            <span className="form-check-label">
                              I Accept Terms and Conditions
                            </span>
                          </label>
                          <div
                            className="modal"
                            style={{
                              display: catModal && terms ? "block" : "none",
                            }}>
                            <div className="modal-dialog" role="document">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <h5 className="modal-title">
                                    Terms Condition
                                  </h5>
                                  <button
                                    type="button"
                                    className="btn-close"
                                    onClick={handleClose}></button>
                                </div>
                                <div className="modal-body">
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: termsAndConditions,
                                    }}
                                  />
                                </div>
                                <div className="modal-footer">
                                  <button
                                    type="button"
                                    className="btn btn-danger light"
                                    data-bs-dismiss="modal"
                                    onClick={handleClose}>
                                    Close
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <button
                            className={"btn btn-success btn-sm w-100"}
                            onClick={proceedToPayment}>
                            PO Generate
                          </button>
                        </div>
                        <div
                          className={
                            "d-flex justify-content-between align-items-center m-0 p-2"
                          }>
                          <h4>Purchase Cart Items</h4>
                          <span>
                            <p
                              className={"mb-0"}
                              style={{
                                fontSize: 12,
                                fontWeight: "bold",
                              }}>
                              Total Items&emsp;:&emsp;
                              <span style={{ float: "right" }}>{totalQty}</span>
                            </p>
                            <p
                              className={"mb-0"}
                              style={{
                                fontSize: 12,
                                fontWeight: "bold",
                              }}>
                              Total PV&emsp;:&emsp;
                              <span style={{ float: "right" }}>{totalPV}</span>
                            </p>
                            <p
                              className={"mb-0"}
                              style={{
                                fontSize: 12,
                                fontWeight: "bold",
                              }}>
                              Sub Total&emsp;:&emsp;
                              <span style={{ float: "right" }}>
                                Rs. {(totalAmount - totalTax)?.toFixed(2)}
                              </span>
                            </p>
                            <p
                              className={"mb-0"}
                              style={{
                                fontSize: 12,
                                fontWeight: "bold",
                              }}>
                              Total Tax&emsp;:&emsp;
                              <span style={{ float: "right" }}>
                                + Rs. {totalTax?.toFixed(2)}
                              </span>
                            </p>
                            <p
                              className={"mb-0"}
                              style={{
                                fontSize: 12,
                                fontWeight: "bold",
                              }}>
                              Delivery Charge&emsp;:&emsp;
                              <span style={{ float: "right" }}>
                                + Rs. {devAmt}
                              </span>
                            </p>
                            <p
                              className={"mb-0"}
                              style={{
                                fontSize: 12,
                                fontWeight: "bold",
                              }}>
                              Grand Total&emsp;:&emsp;
                              <span style={{ float: "right" }}>
                                Rs. {grandTotal.toFixed(2)}
                              </span>
                            </p>
                          </span>
                        </div>
                        <div
                          className={"row"}
                          style={{ height: 400, overflowY: "scroll" }}>
                          <div className={"col-md-12"}>
                            {cartList?.map((value: any, index: number) => {
                              return (
                                <div
                                  key={index}
                                  className={"d-flex p-2"}
                                  style={{ border: "1px solid lightgrey" }}>
                                  <img
                                    className="img-fluid"
                                    src={value.product_image}
                                    alt={value.product_name}
                                    width={80}
                                    style={{
                                      height: 80,
                                      objectFit: "contain",
                                    }}
                                  />
                                  &emsp;
                                  <span className={"w-100"}>
                                    <p
                                      title={value.product_name}
                                      className={"mb-0"}
                                      style={{
                                        fontSize: 12,
                                        fontWeight: "bold",
                                      }}>
                                      {value.product_name.substring(0, 50)}
                                    </p>
                                    <div
                                      className={
                                        "d-flex justify-content-between  align-items-center"
                                      }>
                                      <p
                                        className="badge bg-label-primary mb-0"
                                        style={{
                                          fontSize: 12,
                                          fontWeight: "bold",
                                        }}>
                                        {value.product_code}
                                      </p>
                                      <p className="badge bg-label-warning mb-2">
                                        Minimum Order Quantity is{" "}
                                        {value.min_sale_qty}
                                      </p>
                                    </div>

                                    <div
                                      className={
                                        "d-flex justify-content-between"
                                      }>
                                      <p className={"text-success mb-0"}>
                                        Rs. {value.sell_price}
                                      </p>
                                      <UpdateCart
                                        productId={value.product_id}
                                        getProductList={getProductList}
                                        cartQty={value.qty}
                                        cartData={getCartList}
                                        minSaleQty={value.min_sale_qty}
                                      />
                                    </div>
                                  </span>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="row">
                    <div className="col-md-15 text-center">
                      <div>
                        {requestStatus === "REQUESTED" ? (
                          <>
                            <h4
                              className="badge bg-label-warning mt-4"
                              style={{ fontSize: "16px" }}>
                              Your request has been successfully sent, pending
                              approval from the seller side
                            </h4>
                            <div>
                              <button className="btn btn-sm btn-warning mb-4">
                                {requestStatus}
                              </button>
                            </div>
                          </>
                        ) : (
                          <>
                            <h4
                              className="badge bg-label-danger mt-4"
                              style={{ fontSize: "16px" }}>
                              This seller is private, please send request to
                              seller
                              <br></br>
                              <br></br>
                              first, seller will accept the request after that
                              product will be shown.
                            </h4>
                            <div>
                              <button
                                className="btn btn-sm btn-primary mb-4"
                                onClick={() =>
                                  sendRequest(vendorID, "REQUESTED")
                                }>
                                Send Request
                              </button>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                )
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
    </WebLayout>
  );
};

export default PoGenerate;
